export const dashboardRoutes = {
  name: 'dashboard',
  path: '/dashboard',
  component: () => import('pages/Dashboard/index.vue'),
  meta: {
    title: 'Dashboard',
  },
}
